import { render, staticRenderFns } from "./CostCenterRegister.vue?vue&type=template&id=5c4d1285"
import script from "./CostCenterRegister.vue?vue&type=script&lang=js"
export * from "./CostCenterRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports